<template>
    <div id="ticket-component">
        <AppBreadCrumb :paths="[{ title: $t('message.ticket') }]" :select="true">
            <div v-if="tabIndex === 1">
                <select id="time-select" v-model="timeSelect">
                    <option value="today">{{ $t("time.today") }}</option>
                    <option value="yesterday">
                        {{ $t("time.yesterday") }}
                    </option>
                    <option value="current-week">
                        {{ $t("time.currentWeek") }}
                    </option>
                    <option value="last-week">{{ $t("time.lastWeek") }}</option>
                    <option value="current-month">
                        {{ $t("time.currentMonth") }}
                    </option>
                    <option value="last-month">
                        {{ $t("time.lastMonth") }}
                    </option>
                    <option value="last-30">{{ $t("time.last30Day") }}</option>
                    <option value="all-time">{{ $t("time.allTime") }}</option>
                </select>
            </div>
            <div v-else class="chatListSettingContainer">
                <select id="topic-select" v-model="selectedTopic">
                    <option value="all">{{ $t("message.allTags") }}</option>
                    <option v-for="topic in topics" :value="topic">
                        {{ topic }}
                    </option>
                </select>
                <div
                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                    :content="$t('message.showMyChats')"
                    class="custom-checkbox2"
                    style="margin-left: 6px"
                >
                    <a-switch v-model="showMyTicket" size="small">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                    </a-switch>
                    <span>{{ $t("message.showMyChats") }}</span>
                </div>
            </div>
        </AppBreadCrumb>
        <div class="position-relative pt-3" style="padding: 0 30px">
            <a-row>
                <a-col span="12" style="margin-bottom: 10px">
                    <div class="d-flex">
                        <a-button
                            :class="{
                                'menu-button': tabIndex !== 0,
                                'selected-link': tabIndex === 0,
                            }"
                            class="menu-button-base"
                            @click="tabIndex = 0"
                        >
                            <OfflineSupWaiting
                                :fill="tabIndex === 0 ? '#03a9f4' : '#808184'"
                                style="margin-bottom: -1px; width: 1.25em; margin-right: 1em"
                            />
                            <span style="margin-left: 4px">{{ $t("message.waitingReply") }}</span>
                        </a-button>

                        <a-button
                            :class="{
                                'menu-button': tabIndex !== 1,
                                'selected-link': tabIndex === 1,
                            }"
                            class="menu-button-base"
                            @click="tabIndex = 1"
                        >
                            <ArchiveIcon
                                :fill="tabIndex === 1 ? '#03a9f4' : '#808184'"
                                style="margin-bottom: -1px; width: 1.25em; margin-right: 1em"
                            />
                            <span style="margin-left: 4px">{{ $t("message.archive") }}</span>
                        </a-button>
                        <a-button
                            :class="{
                                'menu-button': tabIndex !== 2,
                                'selected-link': tabIndex === 2,
                            }"
                            class="menu-button-base"
                            @click="tabIndex = 2"
                        >
                            <ArchiveIcon
                                :fill="tabIndex === 2 ? '#03a9f4' : '#808184'"
                                style="margin-bottom: -1px; width: 1.25em; margin-right: 1em"
                            />
                            <span style="margin-left: 4px">{{ $t("ticket.ticketForwarding") }}</span>
                        </a-button>
                    </div>
                </a-col>
                <a-col span="24">
                    <div v-if="tabIndex === 0">
                        <AwaitingTickets :show-my-tickets="showMyTicket" :tag="selectedTopic" />
                    </div>
                    <div v-if="tabIndex === 1">
                        <TicketHistory :timeSelect="timeSelect" />
                    </div>
                    <div v-if="tabIndex === 2">
                        <TicketForwarding />
                    </div>
                </a-col>
            </a-row>
        </div>
        <ChatBar v-if="!isAdmin" :visible="false" />
    </div>
</template>

<script>
import OSRWaitingAnswer from "../../components/svg/OSRWaitingAnswer";
import ArchiveIcon from "../../components/svg/ArchiveIcon";
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import OfflineSupWaiting from "../../components/svg/OfflineSupWaiting";
import AwaitingTickets from "../../components/AwaitingTickets";
import TicketHistory from "../../components/TicketHistory";
import { mapActions, mapState } from "vuex";
import ChatBar from "../../components/ChatBar";
import TicketForwarding from "../../components/TicketForwarding";

export default {
    name: "Ticket",
    data() {
        return {
            timeSelect: "today",
            tabIndex: 0,
            selectedTopic: "all",
            showMyTicket: false,
        };
    },
    components: {
        AppBreadCrumb,
        OSRWaitingAnswer,
        ArchiveIcon,
        OfflineSupWaiting,
        AwaitingTickets,
        TicketHistory,
        ChatBar,
        TicketForwarding,
    },
    computed: {
        ...mapState({
            isAdmin: (state) => state.auth.adminUser != null,
            topics: (state) => state.ticket.topics,
        }),
    },
    methods: {
        ...mapActions({
            fetchTopics: "ticket/fetchTopics",
        }),
    },
    mounted() {
        this.fetchTopics();
    },
};
</script>

<style lang="scss" scoped>
#ticket-component {
    #time-select,
    #topic-select {
        border: none;
        background-color: #f3f6f9;
        padding: 3px 10px;
        border-radius: 6px;
        font-size: 12px;
        font-family: Poppins;
        font-weight: bolder;
        color: #3699ff;
        min-width: 130px;
    }

    .selected-link {
        color: #03a9f4;
        border: none;
        border-radius: initial;
        border-bottom: 2px solid #03a9f4;
        margin-right: 4px;
    }

    svgIcon {
        fill: #03a9f4;
    }

    svgIconTabChange {
        fill: #808184;
    }

    .menu-button {
        margin-right: 4px;
        border: none;
    }

    .menu-button-base {
        background: transparent !important;
    }

    .custom-checkbox2 {
        background-color: #f3f6f9;
        border-radius: 6px;
        padding: 4px 6px;
        max-width: 120px;
        width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        font-family: Poppins;
        font-weight: 400;
        font-size: 12px;
        color: #1e1e2d;
    }

    .chatListSettingContainer {
        display: flex;
        justify-content: left;
        width: 40%;
        position: absolute;
        margin-top: 2px;
        z-index: 50;

        div {
            margin-right: 10px;
        }
    }
}
</style>
